import { http } from "..";

/**
 * Get chats
 *
 * @returns axios http response
 */
export const getChats = () => {
  return http.get("/users/get-chats");
};
